import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import { SpinnerService } from "shared-components";
import { FormBuilder, FormGroup } from "@angular/forms";
import { DataProvider } from "projects/packcert-web/src/app/providers/data.provider";
import { DataService } from "../../../../services/data.service";
import { SessionContextService } from "projects/packcert-web/src/app/context/session-context.service";

@Component({
  selector: "app-estadisticas-etiquetador",
  templateUrl: "./estadisticas-etiquetador.component.html",
})
export class EstadisticasEtiquetadorComponent implements OnInit, OnChanges {
  public estadisticas;

  public tipoEstadisticas = 1;

  @Input() graficasEtiquetadores;
  @Input() allDataDesignaciones;
  @Input() filtrado;

  @Output() showWarning = new EventEmitter<any>(true);

  public gridModal = false;
  public gridTitle;
  public parentDataGrid;
  public dataEtiquetadores;

  constructor(
    private readonly _dataService: DataService,
    private readonly _spinnerService: SpinnerService,
    private readonly _sessionContext: SessionContextService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["allDataDesignaciones"]) {
      if (changes["allDataDesignaciones"].currentValue) {
        this.dataEtiquetadores = changes["allDataDesignaciones"].currentValue;
      }
    }
  }

  ngOnInit() {
    this.showEtiquetadoresPais();
  }

  public get smallScreen() {
    return this._sessionContext.smallScreen;
  }

  public async showEtiquetadoresPais() {
    if (this.filtrado) {
      this._spinnerService.showSpinner();
      await this.delay(1);
      this._spinnerService.hideSpinner();
    }
    this.tipoEstadisticas = 1;
    this.showWarning.emit({
      filtroAnyo: false,
      filtroPais: false,
      filtroDenominacion: false,
      filtroEtiquetador: false,
      tab1: true,
    });
  }

  public async showEtiquetadoresDenominacion() {
    if (this.filtrado) {
      this._spinnerService.showSpinner();
      await this.delay(1);
      this._spinnerService.hideSpinner();
    }
    this.tipoEstadisticas = 2;
    this.showWarning.emit({
      filtroAnyo: false,
      filtroPais: false,
      filtroDenominacion: false,
      filtroEtiquetador: false,
      tab2: true,
    });
  }

  public async showEtiquetadoresDenominaciones() {
    if (this.filtrado) {
      this._spinnerService.showSpinner();
      await this.delay(1);
      this._spinnerService.hideSpinner();
    }
    this.tipoEstadisticas = 3;
    this.showWarning.emit({
      filtroAnyo: false,
      filtroPais: false,
      filtroDenominacion: false,
      filtroEtiquetador: false,
      tab3: true,
    });
  }

  public async showEtiquetadoresAnyo() {
    if (this.filtrado) {
      this._spinnerService.showSpinner();
      await this.delay(1);
      this._spinnerService.hideSpinner();
    }
    this.tipoEstadisticas = 4;
    this.showWarning.emit({
      filtroAnyo: false,
      filtroPais: false,
      filtroDenominacion: false,
      filtroEtiquetador: false,
      tab4: true,
    });
  }

  public showGrid(
    title: string,
    gridArray: Array<any>,
    currentTab: string,
    roundPercentage: string,
    filterBy?: string
  ) {
    console.log("currentTab", currentTab);
    console.log("title", title);
    console.log("gridArray", gridArray);
    console.log("filterBy", filterBy);

    this.gridTitle = title;

    // Resto de pestañas
    if (currentTab === "regularTab") {
      // Filtrado de valores 0
      const filteredGridArray = gridArray.filter((object) => {
        if (object.numEtiquetadores) {
          return object.numEtiquetadores > 0;
        } else if (object.numero) {
          return object.numero > 0;
        }
      });

      // Redondeo de los porcentajes para que coincidan con los mostrados en los donuts/barras
      if (roundPercentage === "donut") {
        const percentagesAltered = filteredGridArray.map((obj) => {
          return {
            ...obj,
            porcentajeEtiquetadores: obj.porcentajeEtiquetadores
              ? obj.porcentajeEtiquetadores.toFixed(1)
              : obj.porcentaje.toFixed(1),
          };
        });
        this.parentDataGrid = percentagesAltered;
      } else if (roundPercentage === "bars") {
        const percentagesAltered = filteredGridArray.map((obj) => {
          return {
            ...obj,
            porcentajeEtiquetadores: obj.porcentajeEtiquetadores
              ? Math.round(obj.porcentajeEtiquetadores)
              : Math.round(obj.porcentaje),
          };
        });
        this.parentDataGrid = percentagesAltered;
      // Para la gráfica de líneas de la pestaña Nº Etiquetadores / Año
      } else if (roundPercentage === '') {
        this.parentDataGrid = gridArray;
      }
    }

    console.log("parentDataGrid", this.parentDataGrid);
    this.gridModal = true;
  }

  public hideModal() {
    this.gridModal = false;
  }

  public delay(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
}
